import { Geometry } from "./webgis.model"

export class RelSchedaProgettoLayerModel {
  flagConvalidato: boolean
  flagEsistente: boolean
  idLayer: number
  idProgetto: number
  idSchedaProgetto: number
  geometry: Geometry
}